export type ApprovalOnboardingDecision = "dual" | "approve-only" | "hold";

/**
 * What confirming an AI Analysis approval offers for the default onboarding flow.
 *
 * `autoSendContractsEnabled` is null until organization settings have loaded.
 * A settings error is the caller's to map (treat as on, which is the default).
 *
 * When auto-send is on and the actor may send Merchant Tasks, the modal shows
 * Approve + Send Contract beside Approve. Otherwise only Approve.
 */
export function approvalOnboardingDecision(options: {
  startDefaultOnboarding: boolean;
  alreadyAccepted: boolean;
  autoSendContractsEnabled: boolean | null;
  canSendMerchantTasks: boolean;
}): ApprovalOnboardingDecision {
  if (!options.startDefaultOnboarding || options.alreadyAccepted) return "approve-only";
  if (options.autoSendContractsEnabled === null) return "hold";
  if (options.autoSendContractsEnabled && options.canSendMerchantTasks) return "dual";
  return "approve-only";
}
